// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useAllId(): {
  data: number[],
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<number[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/department/allid"
    ).then((res: SuccessFetch<{ payload: { departements: { department_id: number }[] }}>) => {
      setData(res.data.payload.departements.map(item => item.department_id))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}